export default __webpack_public_path__ + "groove-green-logo-small.b67c384.png";